import(/* webpackMode: "eager" */ "/vercel/path0/app/buyNow/page.tsx");
